import React, { Children } from 'react';
import { XCircleIcon } from 'lucide-react';
import { SEO } from '../components/seo/SEO';
import { BreadcrumbSchema } from '../components/seo/Schema';
import { IdealPartnerProfile } from '../components/sections/IdealPartnerProfile';
import { motion } from 'framer-motion';
export function WhoWeServe() {
  const notAFit = ['Businesses outside of D2D or direct sales.', 'Startups with zero revenue.', 'Teams looking for a "quick fix" without doing the work.', "Leaders who aren't willing to change their onboarding process.", 'Companies who treat recruiting as a temporary project.'];
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 10
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4,
        ease: [0.25, 0.1, 0.25, 1]
      }
    }
  };
  return <>
      <SEO title="Who We Serve | D2D & Direct Sales Companies | HIRE" description="HIRE works with established D2D and direct sales companies doing $1M+ revenue who are ready to build a real recruiting system. See if you're a fit." canonical="/who-we-serve" ogTitle="Who We Serve | The HIRE Advantage" ogDescription="We partner with D2D and direct sales companies ready to scale. $1M+ revenue, 10+ reps, committed to building systems." keywords="d2d sales companies, direct sales recruiting, door to door business growth, sales team scaling" data-id="element-1889" />

      <BreadcrumbSchema items={[{
      name: 'Home',
      url: '/'
    }, {
      name: 'Who We Serve',
      url: '/who-we-serve'
    }]} data-id="element-1890" />

      <div className="pt-20" data-id="element-1891">
        {/* Ideal Partner Profile as Hero */}
        <IdealPartnerProfile asHero={true} data-id="element-1892" />

        {/* Not a Fit */}
        <section className="section-padding bg-gray-50" data-id="element-1893">
          <div className="container-custom" data-id="element-1894">
            <motion.div className="max-w-3xl mx-auto text-center mb-12" initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.5
          }} data-id="element-1895">
              <h2 className="mb-6" data-id="element-1896">Who We Are NOT For</h2>
              <p className="text-body-large leading-relaxed" data-id="element-1897">
                Let's save us both some time. If this sounds like you, we
                probably aren't a match.
              </p>
            </motion.div>

            <motion.div className="max-w-3xl mx-auto" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6
          }} data-id="element-1898">
              <div className="bg-white rounded-xl p-8 shadow-lg border-2 border-gray-200" data-id="element-1899">
                <motion.ul className="space-y-4" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
                once: true
              }} data-id="element-1900">
                  {notAFit.map((item, index) => <motion.li key={index} className="flex items-start" variants={itemVariants} data-id="element-1901">
                      <XCircleIcon className="h-6 w-6 text-gray-400 flex-shrink-0 mr-3 mt-0.5" data-id="element-1902" />
                      <span data-id="element-1903">{item}</span>
                    </motion.li>)}
                </motion.ul>
              </div>
            </motion.div>

            <motion.div className="mt-12 text-center" initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.4
          }} data-id="element-1904">
              <p className="mb-6" data-id="element-1905">
                We don't force it. The best results come when we are perfectly
                aligned.
              </p>
              <a href="/book-call" className="inline-block bg-slate hover:bg-slate-dark text-white font-bold px-8 py-4 rounded-lg transition-colors shadow-lg" data-id="element-1906">
                Schedule Your Strategy Call →
              </a>
            </motion.div>
          </div>
        </section>

        {/* Final CTA */}
        <section className="section-padding bg-white" data-id="element-1907">
          <div className="container-custom" data-id="element-1908">
            <motion.div className="max-w-3xl mx-auto text-center" initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            duration: 0.6,
            ease: [0.25, 0.1, 0.25, 1]
          }} data-id="element-1909">
              <h2 className="mb-6" data-id="element-1910">Sound Like You?</h2>
              <p className="text-body-large mb-8 leading-relaxed" data-id="element-1911">
                If you are a D2D leader ready to build a real system, let's have
                an honest conversation.
              </p>
              <div className="flex flex-col sm:flex-row gap-4 justify-center" data-id="element-1912">
                <a href="/book-call" className="inline-block bg-slate hover:bg-slate-dark text-white font-bold px-8 py-4 rounded-lg transition-colors shadow-lg" data-id="element-1913">
                  Schedule a Strategy Call →
                </a>
                <a href="/case-studies" className="inline-block border-2 border-navy text-navy hover:bg-navy hover:text-white font-bold px-8 py-4 rounded-lg transition-colors" data-id="element-1914">
                  View Case Studies
                </a>
              </div>
            </motion.div>
          </div>
        </section>
      </div>
    </>;
}